import React, { Fragment, useState } from 'react';
import { Button, Form, FloatingLabel, Row, Col, Container } from 'react-bootstrap';
import VeiculosService from '../../../../../services/veiculos-auth';
import { Link } from 'react-router-dom';
import '../../../../../styles/diario.scss';



const FormBusca = (props) => {
    const [modelo, setModelo] = useState("");
    const [situacao, setSituacao] = useState("");
    const [secretaria, setSecretaria] = useState("");

    const busca = async (query) => {
        if (query == "") {
            await props.fetchVeiculos()
            setModelo("")
        } else {
            var response = await VeiculosService.buscar(query)
            if (response.data.length >= 1) {
                props.setVeiculos(response.data)
                props.setVazio(false)
                setModelo("")
                setSecretaria("")
                setSituacao("")
            } else {
                props.setVazio(true)
                setModelo("")
                setSecretaria("")
                setSituacao("")
            }
        }
    }

    const preparaQuery = async () => {
        let prepQuery = "";
        if (modelo) prepQuery = prepQuery + `&modelo=${encodeURI(modelo)}`;
        if (secretaria !== "false" && secretaria != "false" && secretaria !== "") prepQuery = prepQuery + `&secretaria=${encodeURI(secretaria)}`;
        if (situacao !== "false" && situacao != "false" && situacao !== "") prepQuery = prepQuery + `&situacao=${encodeURI(situacao)}`;
        return prepQuery;
    }

    const handleKeyDown = async (e) => {
        e.preventDefault();
        let finalQuery = await preparaQuery();
        await busca(finalQuery)
    }

    return (
        <Fragment>
            <Container>
                <div className="da-espaco">
                    <Row xs={1} lg={5}>
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="Secretaria">
                                <FloatingLabel
                                    label="Secretaria"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Secretaria"
                                        name="secretaria"
                                        onChange={e => setSecretaria(e.target.value)}
                                    >
                                        <option>SELECIONE</option>
                                        {props.secretarias.map((sec) =>
                                            <option value={sec.nome}>{sec.nome}</option>
                                        )}
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="Situação">
                                <FloatingLabel
                                    label="Situação"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="situacao"
                                        name="situacao"
                                        onChange={e => setSituacao(e.target.value)}
                                    >
                                        <option>SELECIONE</option>
                                        <option value="Ativo">Ativo</option>
                                        <option value="Inativo">Inativo</option>
                                        <option value="Em Manutenção">Em Manutenção</option>
                                        <option value="Aguardando Leilão">Aguardando Leilão</option>
                                        <option value="Perda Total">Perda Total</option>
                                        <option value="Leiloado">Leiloado</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="modelo">
                                <FloatingLabel
                                    label="Modelo"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="modelo"
                                        value={modelo}
                                        onChange={e => setModelo(e.target.value)}
                                    />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Button onClick={async (e) => handleKeyDown(e)} type='button' variant='primary'>Buscar</Button>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Link to='/restrito/veiculos'>
                                <Button type='button' variant='danger'>Voltar</Button>
                            </Link>
                        </Col>
                    </Row>
                </div>
            </Container>
        </Fragment>
    )
}

export default FormBusca
